import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["boxComponent", "className", "children", "component", "fontStyle", "fontWeight", "noWrap", "variant", "color"];
import React from 'react';
import PropTypes from 'prop-types';
import { Box as MuiBox, Typography as MuiTypography } from '@mui/material';
import useStyles from './Typography.styles';
var Typography = function Typography(props) {
  var boxComponent = props.boxComponent,
    className = props.className,
    children = props.children,
    component = props.component,
    fontStyle = props.fontStyle,
    fontWeight = props.fontWeight,
    noWrap = props.noWrap,
    variant = props.variant,
    color = props.color,
    other = _objectWithoutProperties(props, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var fontWeightValue = {
    light: 'fontWeightLight',
    medium: 'fontWeightMedium',
    bold: 'fontWeightBold',
    regular: 'fontWeightRegular'
  }[fontWeight];
  return /*#__PURE__*/React.createElement(MuiTypography, _extends({
    variant: variant,
    className: cx(_defineProperty({}, classes.allowBreak, !noWrap), classes.root, classes[variant], classes[color], className),
    color: color,
    component: component
  }, other), fontWeight || fontStyle ? /*#__PURE__*/React.createElement(MuiBox, {
    fontWeight: fontWeightValue,
    fontStyle: fontStyle,
    component: boxComponent
  }, children) : children);
};
process.env.NODE_ENV !== "production" ? Typography.propTypes = {
  align: PropTypes.string,
  boxComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
  gutterBottom: PropTypes.bool,
  noWrap: PropTypes.bool,
  paragraph: PropTypes.bool,
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  display: PropTypes.oneOf(['initial', 'block', 'inline']),
  fontStyle: PropTypes.oneOf(['normal', 'italic', 'oblique']),
  fontWeight: PropTypes.oneOf(['light', 'regular', 'medium', 'bold', PropTypes.number]),
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption']),
  component: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div', 'span', 'a'])
} : void 0;
Typography.defaultProps = {
  align: 'left',
  color: 'initial',
  variant: 'body1',
  component: 'span'
};
export default Typography;